module.exports = __webpack_public_path__ + "static/media/map_marker.fcaa994a.svg";